export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  role: UserRole
  status?: UserStatus
  isVerified: boolean
  isActive: boolean
  isOnboardingComplete: boolean
  profile: UserProfile
  notificationPreferences?: NotificationPreferences
  createdAt: string
  updatedAt: string
}

export interface NotificationPreferences {
  emailNotifications: boolean
  inAppNotifications: boolean
}

export interface UserProfile {
  bio?: string
  expertise: string[]
  interests: string[]
  goals: string[]
  profilePicture?: string
  hasUploadedPicture?: boolean
  location?: string
  timezone?: string
  maxMentees?: number
  isAvailable?: boolean
}

export enum UserRole {
  MENTOR = 'mentor',
  MENTEE = 'mentee',
  ADMIN = 'admin'
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_VERIFICATION = 'pending_verification',
  SUSPENDED = 'suspended',
  DEACTIVATED = 'deactivated'
}

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  password: string
  firstName: string
  lastName: string
  role: UserRole
}

export interface AuthResponse {
  user: User
  token: string
  refreshToken: string
}

export interface UpdateProfileRequest {
  firstName?: string
  lastName?: string
  profile?: Partial<UserProfile>
  notificationPreferences?: Partial<NotificationPreferences>
}